import RouteModel from "../../model-factory/basic/route/RouteModel";
import {RouteKey, FactoryID} from "../../model-factory/type-interface/ModelFactoryType";
import RouteFactory from "../../model-factory/basic/route/RouteFactory";
import RouteChoice from "../../model-factory/basic/route/RouteChoice";
import {getManager} from "../../manager/Manager";
import {IRouteIDs} from "../../model-factory/type-interface/ModelFactoryInterface";
import {logIn, paperPlaneOutline, paperPlaneSharp} from "ionicons/icons";

export class AccountRouteModel extends RouteModel
{

    navigationRouteKey: RouteKey = "account_route_id";
    choiceOrder = ["login", "register", "password_reset"];


    createChoiceOrder(): string[]|null
    {
        if(getManager().user.loggedInLocal){
            if(getManager().user.organisationID){
                return ["edit_personal_details", "edit_organisation_profile", "change_password", "account_close"];
            }
            return ["edit_personal_details", "change_password", "account_close"];
        }
        return null;
    }
}

export default class AccountRouteFactory extends RouteFactory
{

    id: FactoryID = "account_route";

    isUserDependant: boolean = true;

    constructor()
    {
        super();


        this.choices = {
            login: new RouteChoice({
                name: "Login",
                sideMenuIcons: {
                    iosIcon: logIn,
                    mdIcon: logIn
                }
            }),
            register: new RouteChoice({
                name: "Register"
            }),
            password_reset: new RouteChoice({
                name: "Forgot Password?"
            }),
            edit_personal_details: new RouteChoice({
                name: "Edit your Personal Details"
            }),
            edit_organisation_profile: new RouteChoice({
                name: "Edit your Organisation's Profile",
                derivedRouteIDs: {
                    post_type: "organisation"
                }
            }),
            change_password: new RouteChoice({
                name: "Change Password"
            }),
            account_close: new RouteChoice({
                name: "Close Account",
            })
        }
    }

    birth(id: FactoryID): AccountRouteModel
    {
        return new AccountRouteModel(id);
    }

    getDefaultModel(): AccountRouteModel
    {
        return this.getDefaultModelWithRoute()! as AccountRouteModel;
    }

    defaultRouteIDs(): IRouteIDs
    {
        return {
            browse_route_id: "my_profile",
            my_profile_route_id: "account"
        };
    }
}